import styled from 'styled-components';
import { appConfig } from './config';

const AppBodyDefault = styled.div`
  font-size: ${(props) => props.theme.assets.fonts.normal};
  color: ${(props) => props.theme.colors.text.textColor};
  font-weight: ${(props) => props.theme.assets.fonts.fontWeight};
  height: 100%;
  overflow-x: hidden;
  font-family: ${(props) => props.theme.assets.fonts.fontFamily};
`;

const AppBodyDisona = styled.div`
  font-size: ${(props) => props.theme.assets.fonts.normal};
  color: ${(props) => props.theme.colors.text.textColor};
  font-weight: ${(props) => props.theme.assets.fonts.fontWeight};
  font-family: ${(props) => props.theme.assets.fonts.fontFamily};
  overflow-y: hidden;
`;

export default appConfig.whiteLabelPartner === 'disona'
  ? AppBodyDisona
  : AppBodyDefault;
